import { User, UserRole } from '../../types';
import api from './client';

/**
 * Staff accounts. Scoped server-side to the caller's shop; a super admin sees
 * every shop's. Account *creation* goes through `authService.register`, which
 * is what owns password hashing.
 */
export const usersService = {
  /** `role` narrows the list server-side rather than in the browser. */
  getAllUsers: async (role?: UserRole): Promise<User[]> => {
    const response = await api.get<User[]>('/users', {
      params: role ? { role } : undefined,
    });
    return response.data;
  },
  getUserById: async (id: string): Promise<User> => {
    const response = await api.get<User>(`/users/${id}`);
    return response.data;
  },
  updateUser: async (
    id: string,
    payload: { name?: string; email?: string; role?: UserRole },
  ): Promise<User> => {
    const response = await api.patch<User>(`/users/${id}`, payload);
    return response.data;
  },
  deleteUser: async (id: string): Promise<void> => {
    await api.delete(`/users/${id}`);
  },
};
